export enum EScreenSize {
    md = 576,
    xl = 1280,
}